import type { ObjectId } from 'mongodb';

import { MilestoneRequirement } from './Milestones';
import { ProgramType } from './ProgramTypes';

export enum RequirementFlagSettingsType {
  accessoriesHVAC = 'accessoriesHVAC',
  accessoriesWaterHeater = 'accessoriesWaterHeater',
  accessToLightReachBattery = 'accessToLightReachBattery',
  accessToLightReachInverter = 'accessToLightReachInverter',
  ahriNumber = 'ahriNumber',
  ahriCertificate = 'ahriCertificate',
  approvedInterconnectionAgreement = 'approvedInterconnectionAgreement',
  approvedPermit = 'approvedPermit',
  arbitrageBattery = 'arbitrageBattery',
  backupBattery = 'backupBattery',
  batteryMonitoringId = 'batteryMonitoringId',
  billOfMaterials = 'billOfMaterials',
  cslbDisclosure = 'cslbDisclosure',
  conditionalApprovalRemedy = 'conditionalApprovalRemedy',
  configurationSettingsBattery = 'configurationSettingsBattery',
  configurationSettingsLayoutInverter = 'configurationSettingsLayoutInverter',
  customerContract = 'customerContract',
  designPlanSet = 'designPlanSet',
  designProductionModel = 'designProductionModel',
  designShadeReport = 'designShadeReport',
  disclosure = 'disclosure',
  domesticContentPhotos = 'domesticContentPhotos',
  domesticContentDocuments = 'domesticContentDocuments',
  electrical = 'electrical',
  electricalUpgrade = 'electricalUpgrade',
  electricianSignOff = 'electricianSignOff',
  energyBackupInstallationPhotos = 'energyBackupInstallationPhotos',
  equipmentHVAC = 'equipmentHVAC',
  equipmentWaterHeater = 'equipmentWaterHeater',
  existingSystemEnergyBackup = 'existingSystemEnergyBackup',
  existingSystemPhotos = 'existingSystemPhotos',
  fieldServiceManagementChecklistHVAC = 'fieldServiceManagementChecklistHVAC',
  hvacInstallationPhotos = 'hvacInstallationPhotos',
  incentive = 'incentive',
  indoorSystem = 'indoorSystem',
  installContractHVAC = 'installContractHVAC',
  inverterMonitoringId = 'inverterMonitoringId',
  invoice = 'invoice',
  incomingDirectPayInvoice = 'incomingDirectPayInvoice',
  outdoorSystem = 'outdoorSystem',
  measureSystemVitalsHVAC = 'measureSystemVitalsHVAC',
  mountingHardware = 'mountingHardware',
  netMeteringApproval = 'netMeteringApproval',
  onSitePhysicalSurvey = 'onSitePhysicalSurvey',
  photoVoltaicSystem = 'photoVoltaicSystem',
  projectSite = 'projectSite',
  projectSiteHVAC = 'projectSiteHVAC',
  proofOfEquipment = 'proofOfEquipment',
  proofOfExtendedWarranty = 'proofOfExtendedWarranty',
  proofOfLoadCalculation = 'proofOfLoadCalculation',
  proofOfLoadCalculationHVAC = 'proofOfLoadCalculationHVAC',
  proofOfPermissionToOperate = 'proofOfPermissionToOperate',
  puertoRicoDocuments = 'puertoRicoDocuments',
  remoteDataLoggingReportHVAC = 'remoteDataLoggingReportHVAC',
  roof = 'roof',
  serialNumber = 'serialNumber',
  siteEligibility = 'siteEligibility',
  siteImprovement = 'siteImprovement',
  solarReadiness = 'solarReadiness',
  staticPressureReadings = 'staticPressureReadings',
  storage = 'storage',
  systemCommissioning = 'systemCommissioning',
  systemCostDiscrepancyHVAC = 'systemCostDiscrepancyHVAC',
  systemDesignIssueEnergyBackup = 'systemDesignIssueEnergyBackup',
  systemDesignIssueHVAC = 'systemDesignIssueHVAC',
  systemInstallDateHVAC = 'systemInstallDateHVAC',
  temperatureDiffOfReturnAndSupply = 'temperatureDiffOfReturnAndSupply',
  thermostat = 'thermostat',
  utilityBill = 'utilityBill',
  welcomeCall = 'welcomeCall',
  yearOneProductionEstimate = 'yearOneProductionEstimate',
  zoningSystemHVAC = 'zoningSystemHVAC',
  zoningSystem = 'zoningSystem',
  waterHeaterInstallationPhotos = 'waterHeaterInstallationPhotos',
  projectSiteWaterHeater = 'projectSiteWaterHeater',
  systemCostDiscrepancyWaterHeater = 'systemCostDiscrepancyWaterHeater',
  systemInstallDateWaterHeater = 'systemInstallDateWaterHeater',
  equipmentDataPlateWaterHeater = 'equipmentDataPlateWaterHeater',
  wideInstallationViewWaterHeater = 'wideInstallationViewWaterHeater',
  tpReliefValveWaterHeater = 'tpReliefValveWaterHeater',
  drainPanDrainLineWaterHeater = 'drainPanDrainLineWaterHeater',
  indoorSystemWaterHeater = 'indoorSystemWaterHeater',
  generatorInstallationPhotos = 'generatorInstallationPhotos',
  projectSiteGenerator = 'projectSiteGenerator',
  systemCostDiscrepancyGenerator = 'systemCostDiscrepancyGenerator',
  systemInstallDateGenerator = 'systemInstallDateGenerator',
  equipmentDataPlateGenerator = 'equipmentDataPlateGenerator',
  wideInstallationViewGenerator = 'wideInstallationViewGenerator',
  transferSwitchGenerator = 'transferSwitchGenerator',
  fuelConnectionGenerator = 'fuelConnectionGenerator',
  remoteMonitoringSetupGenerator = 'remoteMonitoringSetupGenerator',
  cellularDeviceIdGenerator = 'cellularDeviceIdGenerator',
  mainServicePanelGenerator = 'mainServicePanelGenerator',
  loadControlDevicesGenerator = 'loadControlDevicesGenerator',
  fieldProFuelLinePressureGenerator = 'fieldProFuelLinePressureGenerator',
  fieldProSystemRuntimeGenerator = 'fieldProSystemRuntimeGenerator',
  equipmentGenerator = 'equipmentGenerator',
  installContractGenerator = 'installContractGenerator',
  oemWarrantyDocuments = 'oemWarrantyDocuments',
  geothermalInstallationPhotos = 'geothermalInstallationPhotos',
  equipmentDataPlateGeothermal = 'equipmentDataPlateGeothermal',
  mechanicalRoomWideShotGeothermal = 'mechanicalRoomWideShotGeothermal',
  flowCenterGeothermal = 'flowCenterGeothermal',
  loopFieldPhotoGeothermal = 'loopFieldPhotoGeothermal',
  electricalDisconnectGeothermal = 'electricalDisconnectGeothermal',
  thermostatGeothermal = 'thermostatGeothermal',
  equipmentGeothermal = 'equipmentGeothermal',
  systemCostDiscrepancyGeothermal = 'systemCostDiscrepancyGeothermal',
  systemInstallDateGeothermal = 'systemInstallDateGeothermal',
  projectSiteGeothermal = 'projectSiteGeothermal',
  systemMonitoringId = 'systemMonitoringId',
  communityName = 'communityName',
  executedEscrowAgreement = 'executedEscrowAgreement',
}

export const FlagTypeLabels: Record<RequirementFlagSettingsType, string> = {
  accessoriesHVAC: 'Accessories',
  accessoriesWaterHeater: 'Accessories',
  accessToLightReachBattery: 'Access to LightReach - Battery',
  accessToLightReachInverter: 'Access to LightReach - Inverter',
  ahriNumber: 'AHRI Number',
  ahriCertificate: 'AHRI Certificate',
  approvedInterconnectionAgreement: 'Approved Interconnection Agreement',
  approvedPermit: 'Approved Permit',
  arbitrageBattery: 'Arbitrage Battery',
  backupBattery: 'Backup Battery',
  batteryMonitoringId: 'Battery Monitoring Id',
  billOfMaterials: 'Bill of Materials',
  cslbDisclosure: 'CSLB Disclosure',
  conditionalApprovalRemedy: 'Conditional Approval Remedy',
  configurationSettingsBattery: 'Configuration and Settings - Battery',
  configurationSettingsLayoutInverter: 'Configuration, Settings, and Layout - Inverter',
  customerContract: 'Customer Contract',
  designPlanSet: 'Design Plan Set',
  designProductionModel: 'Design Production Model',
  designShadeReport: 'Design Shade Report',
  disclosure: 'Disclosure',
  domesticContentPhotos: 'Domestic Content Photos',
  domesticContentDocuments: 'Domestic Content Documents',
  electrical: 'Electrical',
  electricalUpgrade: 'Electrical Upgrade',
  electricianSignOff: 'Electrician SignOff',
  energyBackupInstallationPhotos: 'Energy Backup Installation Photos',
  equipmentHVAC: 'Equipment',
  equipmentWaterHeater: 'Equipment',
  existingSystemEnergyBackup: 'Existing System',
  existingSystemPhotos: 'Existing System Photos',
  fieldServiceManagementChecklistHVAC: 'Field Service Management Checklist',
  hvacInstallationPhotos: 'HVAC Installation Photos',
  incentive: 'Incentive',
  indoorSystem: 'Indoor System',
  installContractHVAC: 'Install Contract',
  inverterMonitoringId: 'Inverter Monitoring Id',
  invoice: 'Invoice',
  incomingDirectPayInvoice: 'Incoming Direct Pay Invoice',
  onSitePhysicalSurvey: 'On-Site Physical Survey',
  outdoorSystem: 'Outdoor System',
  measureSystemVitalsHVAC: 'Measure System Vitals',
  mountingHardware: 'Mounting Hardware',
  netMeteringApproval: 'Net Metering Approval',
  photoVoltaicSystem: 'PV System',
  projectSite: 'Project Site',
  projectSiteHVAC: 'Project Site',
  proofOfEquipment: 'Proof of Equipment',
  proofOfExtendedWarranty: 'Proof of Extended Warranty',
  proofOfLoadCalculation: 'Proof of Load Calculation',
  proofOfLoadCalculationHVAC: 'Proof of Load Calculation',
  proofOfPermissionToOperate: 'Proof of Permission to Operate',
  puertoRicoDocuments: 'Puerto Rico Documents',
  remoteDataLoggingReportHVAC: 'Remote Data Logging Report',
  roof: 'Roof',
  serialNumber: 'Serial Number',
  siteEligibility: 'Site Eligibility',
  siteImprovement: 'Site Improvement',
  solarReadiness: 'Solar Readiness',
  staticPressureReadings: 'Static Pressure Readings',
  storage: 'Storage',
  systemCommissioning: 'System Commissioning',
  systemCostDiscrepancyHVAC: 'System Cost Discrepancy',
  systemDesignIssueEnergyBackup: 'System Design Issue',
  systemDesignIssueHVAC: 'System Design Issue',
  systemInstallDateHVAC: 'System Install Date',
  temperatureDiffOfReturnAndSupply: 'Temperature Diff Of Return And Supply',
  thermostat: 'Thermostat',
  utilityBill: 'Utility Bill',
  welcomeCall: 'Welcome Call',
  yearOneProductionEstimate: 'Year-1 Production Estimate',
  zoningSystemHVAC: 'System Design Zoning',
  zoningSystem: 'Zoning System',
  waterHeaterInstallationPhotos: 'Water Heater Installation Photos',
  projectSiteWaterHeater: 'Project Site',
  systemCostDiscrepancyWaterHeater: 'System Cost Discrepancy',
  systemInstallDateWaterHeater: 'System Install Date',
  equipmentDataPlateWaterHeater: 'Equipment Data Plate',
  wideInstallationViewWaterHeater: 'Wide Installation View',
  tpReliefValveWaterHeater: 'Temperature & Pressure (T&P) Relief Valve',
  drainPanDrainLineWaterHeater: 'Drain Pan & Drain Line',
  indoorSystemWaterHeater: 'Indoor System',
  generatorInstallationPhotos: 'Generator Installation Photos',
  projectSiteGenerator: 'Project Site',
  systemCostDiscrepancyGenerator: 'System Cost Discrepancy',
  systemInstallDateGenerator: 'System Install Date',
  equipmentDataPlateGenerator: 'Equipment Data Plate',
  wideInstallationViewGenerator: 'Wide Installation View',
  transferSwitchGenerator: 'Transfer Switch / ATS',
  fuelConnectionGenerator: 'Fuel Connection',
  remoteMonitoringSetupGenerator: 'Remote Monitoring Setup',
  cellularDeviceIdGenerator: 'Cellular Device ID',
  mainServicePanelGenerator: 'Main Service Panel',
  loadControlDevicesGenerator: 'Load Control Devices',
  fieldProFuelLinePressureGenerator: 'FieldPro Screenshots: Fuel Line Pressure Test',
  fieldProSystemRuntimeGenerator: 'FieldPro Screenshots: System Runtime',
  equipmentGenerator: 'Equipment',
  installContractGenerator: 'Install Contract',
  oemWarrantyDocuments: 'OEM Warranty Documents',
  executedEscrowAgreement: 'Executed Escrow Agreement',
  geothermalInstallationPhotos: 'Geothermal Installation Photos',
  equipmentDataPlateGeothermal: 'Equipment Data Plate',
  mechanicalRoomWideShotGeothermal: 'Mechanical Room Wide Shot',
  flowCenterGeothermal: 'Flow Center',
  loopFieldPhotoGeothermal: 'Loop Field Photo',
  electricalDisconnectGeothermal: 'Electrical Disconnect',
  thermostatGeothermal: 'Thermostat',
  equipmentGeothermal: 'Equipment',
  systemCostDiscrepancyGeothermal: 'System Cost Discrepancy',
  systemInstallDateGeothermal: 'System Install Date',
  projectSiteGeothermal: 'Project Site',
  systemMonitoringId: 'System Monitoring ID',
  communityName: 'Community Name',
};

export interface RequirementAcceptanceProblem {
  id: ObjectId;
  index?: number;
  details: string[];
  displayText: string;
  canBeRemoved?: boolean;
}

export enum FlagCriteriaFilterType {
  addressState = 'addressState',
}

export interface FlagCriteriaFilter {
  value: string;
  type: FlagCriteriaFilterType;
}

export enum RequirementAcceptanceTriggerType {
  contractGenerated = 'contractGenerated',
  contractReverted = 'contractReverted',
}

export interface RequirementAcceptanceCriterion {
  id: ObjectId;
  index?: number;
  displayText: string;
  description?: string;
  knowledgeBaseArticle?: string;
  problems: RequirementAcceptanceProblem[];
  filters?: FlagCriteriaFilter[];
  /**
   * The type of trigger or event that activates this acceptance criterion.
   * Used to match specific scenarios within a requirement flag setting type.
   */
  triggerType?: RequirementAcceptanceTriggerType;
  /**
   * Whether this acceptance criterion can be removed by users.
   */
  canBeRemoved?: boolean;
}

export enum RequirementFlagSettingsStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum RequirementFlagSettingsItemType {
  acceptanceCriterion = 'acceptanceCriterion',
  problem = 'problem',
}

export interface RequirementFlagSettingsDocument {
  id: ObjectId;
  type: RequirementFlagSettingsType;
  name: string;
  description?: string;
  knowledgeBaseArticle?: string;
  meetsAccountRequirements?: MilestoneRequirement[];
  baseCategory?: string;
  dataKey?: string;
  acceptanceCriteria?: RequirementAcceptanceCriterion[];
  programTypes: ProgramType[];
  status: RequirementFlagSettingsStatus;
  isEditable: boolean;
  isFilterable?: boolean;
}

export interface FlagDisplayTextUpdate {
  id: string;
  parentId?: string;
  displayText: string;
  description?: string;
  knowledgeBaseArticle?: string;
  stateFilter?: string;
  details?: string;
}

export interface RequirementFlagSettingPostRequest {
  type: RequirementFlagSettingsType;
  name: string;
  description?: string;
  meetsAccountRequirements?: MilestoneRequirement[];
  baseCategory?: string;
  dataKey?: string;
  programTypes: ProgramType[];
  isFilterable?: boolean;
}

export interface RequirementFlagSettingPatchRequest {
  displayTextDiffs?: {
    acceptanceCriteria: FlagDisplayTextUpdate[];
    problems: FlagDisplayTextUpdate[];
  };
  addItem?: {
    itemType: RequirementFlagSettingsItemType;
    item: Partial<RequirementAcceptanceCriterion> | Partial<RequirementAcceptanceProblem>;
    parentId?: string;
  };
  removeItem?: { itemType: RequirementFlagSettingsItemType; id: string };
  status?: RequirementFlagSettingsStatus;
}
